module.exports = __webpack_public_path__ + "img/wanage.05b8d1e7.jpg";